import { useStore } from "@/stores/useStore";
import { useCardFiltering } from "@/hooks/useCardFiltering";
import { useRoPanelParams } from "@/hooks/useRoPanelParams";
import { useSearchResults } from "@/hooks/useSearchResults";
import { getCardSection } from "@/lib/cards";
import { SearchResultsEmptyState } from "@/components/Common/SearchResultsPanel/SearchResultsEmptyState";

export const SearchResultsTab = () => {
  const shop = useStore((s) => s.shop);
  const { filteredCards, search } = useCardFiltering();
  const { selectCard } = useRoPanelParams();
  const results = useSearchResults(filteredCards);

  if (!shop) return null;

  if (results.length === 0) {
    return <SearchResultsEmptyState search={search} />;
  }

  return (
    <div className="flex h-full w-full flex-col overflow-auto p-4">
      <p className="mb-3 text-sm font-semibold text-foreground">
        {results.length} result{results.length === 1 ? "" : "s"} for &ldquo;
        {search}&rdquo;
      </p>
      <ul className="flex flex-col gap-2">
        {results.map(({ card, containerName, layoutNames }) => (
          <li key={card.id}>
            <button
              type="button"
              onClick={() => selectCard(card.id)}
              className="flex w-full flex-col items-start gap-0.5 rounded-md border border-slate-200 p-3 text-left hover:bg-slate-50"
            >
              <span className="text-sm font-semibold text-foreground">
                {getCardSection(card, shop, "primaryField")}
              </span>
              <span className="text-xs font-medium text-foreground">
                {getCardSection(card, shop, "secondaryField")}
              </span>
              <span className="text-xs text-muted-foreground">
                {containerName}
                {layoutNames.length > 0 ? ` · ${layoutNames.join(", ")}` : ""}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
